import * as stringHash from "string-hash";

export function createHttpExampleKey(docTitle: string, method: string, url: string) {
	return stringHash(`${method}${url}${docTitle}`);
}

export function createJsExampleKey(docTitle: string, code: string) {
	return stringHash(`${code}${docTitle}`);
}



// WEBPACK FOOTER //
// ./src/utils/example_key.ts